import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import AppButton from "components/app-button";
import congrats from "assets/images/components/pages/onboard/congrats.png";

const AppWelcomeOnboardModal = (props, ref) => {
	const [visible, setVisible] = useState(false);

	const onHandleShow = useCallback(() => {
		setVisible(true);
	}, []);

	const onHandleDismiss = useCallback(() => {
		setVisible(false);
	}, []);

	//prettier-ignore
	useImperativeHandle(ref, () => ({
		onHandleShow: onHandleShow,
		onHandleDismiss: onHandleDismiss,
	}));

	return (
		<Modal classes={{ root: "app-welcome-onboard-modal" }} open={visible} aria-labelledby="app-welcome-onboard" aria-describedby="app-welcome-onboard">
			<div className="welcome-onboard-modal">
				<img className="welcome-onboard-modal__congrats" src={congrats} alt="congrats" />

				<div className="welcome-onboard-modal__header">
					<p className="welcome-onboard-modal__title">Welcome Onboard!</p>
					<p className="welcome-onboard-modal__description">You have successfully joined the company.</p>
				</div>

				<div className="welcome-onboard-modal__button-container">
					<AppButton type="button" label="Okay" onClick={onHandleDismiss} />
				</div>
			</div>
		</Modal>
	);
};

export default memo(forwardRef(AppWelcomeOnboardModal));

AppWelcomeOnboardModal.propTypes = {
	ref: PropTypes.object,
};
